import { useEffect } from 'react';
import { setI18nDebugContext } from './debug-context';

export function useI18nDebugContext(descriptorId?: string): void {
  useEffect(() => {
    setI18nDebugContext({
      descriptorId,
      route: typeof window !== 'undefined' ? window.location.pathname : undefined,
    });

    return () => {
      setI18nDebugContext(null);
    };
  }, [descriptorId]);
}
